import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { show as showModal } from 'redux-modal';
import classnames from 'classnames';
import PathModal, { MODAL_NAME as PATHWAY_MODAL } from './PathModal';
import styles from './index.module.scss';

const pathwayData = {
  MATHEMATICS_PATH: {
    title: 'Mathematics for Data Analytics',
    img: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Mathematics+for+Data+Analytics.png',
    description: `
      This short course covers the foundational knowledge of Statistics and Linear Algebra. Topics taught include descriptive statistical measures such as central tendencies, standard deviations and distributions and inferential statistical measures such as correlation. The module also covers basic linear algebra such as matrix operations.
    `,
    more: 'https://www.cet.np.edu.sg/courses/mathematics-for-data-analytics/',
  },
  DATA_VISUALISATION_PATH: {
    title: 'Data Visualisation Primer',
    img: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Data+Visualisation+Primer.png',
    description: `
      This short course covers the theory and techniques for creating effective visualisations based on graphic design. Learners will apply these principles and techniques to create rich visualisations for analysis and presentation using widely popular tools e.g. Tableau.
    `,
    more: 'https://www.cet.np.edu.sg/courses/data-visualisation-primer/',
  },
  DATA_STORYTELLING_AND_DESIGN: {
    title: 'Data Storytelling & Design',
    img: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Data+Storytelling+%26+Design.png',
    description: `
      This short course covers various narrative structures that can be adapted to data presentation with the aim to addressing a business objective. Core design essentials and best practices will also be covered in this module.
    `,
    more: 'https://www.cet.np.edu.sg/courses/data-storytelling-and-design/',
  },
  BUSINESS_CONCEPTS_AND_INSIGHT: {
    title: 'Business Concepts & Insights',
    img: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/Business+Concepts+%26+Insights.png',
    description: `
      This short course provides the students with a broad coverage of business concepts, its drivers and operations. The course takes a practical approach to walk through how data can be used for business to make decisions and drive business performance using drag and drop visual machine learning tools.
    `,
    more: 'https://www.cet.np.edu.sg/courses/business-concepts-and-insights/',
  },
  PROGRAMMING_FOUNDATIONS_FOR_ANALYTICS: {
    title: 'Programming Foundations For Analytics',
    img:
      'https://indorse-staging-bucket.s3.amazonaws.com/vital/Programming+Foundations+for+Analytics.png',
    description: `
      This short course introduces the student to the world of programming and problem solving. Basics programming constructs such as conditionals, loops and functions will be covered. The course takes the lens of data analytics in the delivery of the programming concepts.
    `,
    more: 'https://www.cet.np.edu.sg/courses/programming-foundations-for-analytics/',
  },
  DATA_HACKATHON: {
    title: 'Data Hackathon',
    img: 'https://indorse-staging-bucket.s3.amazonaws.com/vital/DATA+HACKATHON.png',
    description: `
      This is a 2-day capstone event which gives course participants the opportunity to show and tell all they have learnt over the previous 4 months or so. Working in groups of 4-5, after being presented with a business problem statement, participants will proceed to discuss, collaborate and apply data analytical tools and present data and insights to key decision makers.
    `,
  },
};

const CourseCard = ({ title, img, openModal, size, className, style }) => {
  return (
    <div className="d-flex justify-content-center">
      <img
        src={img}
        alt={title}
        onClick={openModal}
        style={style}
        className={classnames(
          size === 'md' && styles.courseCardMd,
          size === 'xl' && styles.courseCardXl,
          size === 'xxl' && styles.courseCardXxl,
          size === 'sm' && styles.courseCardSm,
          'cursor-pointer',
          //size === 'sm' && 'my-4',
          className
        )}
      />
    </div>
  );
};

// const ModuleCard = ({ title, img, link, size, className }) => {
//   const Module = (
//     <img
//       src={img}
//       alt={title}
//       className={classnames(
//         size === 'md' && styles.courseCardMd,
//         size === 'xl' && styles.courseCardXl,
//         size === 'xxl' && styles.courseCardXxl,
//         size === 'sm' && styles.courseCardSm,
//         'mx-auto cursor-pointer',
//         className
//       )}
//     />
//   );
//   if (link) {
//     return (
//       <a href={link} target="_blank noopener noreferrer">
//         {Module}
//       </a>
//     );
//   } else {
//     return Module;
//   }
// };

const pathway = props => {
  return (
    <div>
      <CourseCard
        style={{ width: '540px', marginLeft: '3rem' }}
        {...pathwayData.MATHEMATICS_PATH}
        openModal={() => props.showModal(PATHWAY_MODAL, { ...pathwayData.MATHEMATICS_PATH })}
        size="sm"
      />
      <CourseCard
        style={{ width: '540px', marginLeft: '-4.2rem' }}
        {...pathwayData.PROGRAMMING_FOUNDATIONS_FOR_ANALYTICS}
        openModal={() =>
          props.showModal(PATHWAY_MODAL, { ...pathwayData.PROGRAMMING_FOUNDATIONS_FOR_ANALYTICS })}
        size="md"
      />
      <CourseCard
        style={{ width: '520px', marginLeft: '3rem' }}
        {...pathwayData.DATA_VISUALISATION_PATH}
        openModal={() => props.showModal(PATHWAY_MODAL, { ...pathwayData.DATA_VISUALISATION_PATH })}
        size="sm"
      />
      <CourseCard
        style={{ width: '560px', margin: '-1rem 0 0 -6rem' }}
        {...pathwayData.DATA_STORYTELLING_AND_DESIGN}
        openModal={() =>
          props.showModal(PATHWAY_MODAL, { ...pathwayData.DATA_STORYTELLING_AND_DESIGN })}
        size="sm"
      />
      <CourseCard
        style={{ width: '560px', marginLeft: '6rem' }}
        {...pathwayData.BUSINESS_CONCEPTS_AND_INSIGHT}
        openModal={() =>
          props.showModal(PATHWAY_MODAL, { ...pathwayData.BUSINESS_CONCEPTS_AND_INSIGHT })}
        size="md"
      />
      <CourseCard
        style={{ width: '540px', margin: '1rem 0 0 -4rem' }}
        {...pathwayData.DATA_HACKATHON}
        openModal={() => props.showModal(PATHWAY_MODAL, { ...pathwayData.DATA_HACKATHON })}
        size="md"
      />
      <PathModal />
    </div>
  );
};

function mapStateToProps(state, ownProps) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: bindActionCreators(showModal, dispatch),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(pathway);



// WEBPACK FOOTER //
// ./src/ui/pages/home/pathway.js